package com.nonopn.skywatcher.common.app.portfolio.selected

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.material.Scaffold
import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.ui.Modifier
import com.nonopn.skywatcher.common.app.drawer.DrawerSizeShape
import com.nonopn.skywatcher.common.app.home.AppModel
import com.nonopn.skywatcher.common.app.home.LocalApp
import com.nonopn.skywatcher.common.app.home.LocalAppBarProvider
import com.nonopn.skywatcher.common.app.home.LocalMenuState
import com.nonopn.skywatcher.common.app.home.LocalThunderDetectionModel
import com.nonopn.skywatcher.common.app.navigation.PossibleRoutes
import com.nonopn.skywatcher.common.app.navigation.RouterDetection
import com.nonopn.skywatcher.common.app.navigation.scaffold.FloatingActionButtonWrapper
import com.nonopn.skywatcher.common.app.navigation.scaffold.TopBarWrapper
import com.nonopn.skywatcher.common.app.pages.sentinels.ThunderDetectionWithMetadata
import com.nonopn.skywatcher.design.widgets.rememberSizeAwareScaffoldState
import eu.codlab.navigation.LocalNavigator
import eu.codlab.navigation.NavigateTo
import eu.codlab.navigation.NavigatorLocalProvider
import eu.codlab.navigation.ScaffoldContentWrapper
import eu.codlab.safearea.views.SafeArea
import eu.codlab.safearea.views.SafeAreaBehavior
import eu.codlab.viewmodel.rememberViewModel

@Composable
@Suppress("LongMethod", "ComplexMethod")
fun ThunderDetectionSelectedContent(
    model: AppModel,
    thunderDetection: ThunderDetectionWithMetadata
) {
    val scaffoldState = rememberSizeAwareScaffoldState()

    val appModelState by LocalApp.current.states.collectAsState()
    val selectedThunderDetection: ThunderDetectionWithMetadata? by remember { mutableStateOf(null) }

    val scope = rememberCoroutineScope()

    LaunchedEffect(scaffoldState) {
        scaffoldState.drawerState.close()
    }

    val selectedThunderDetectionSelectedModel: ThunderDetectionSelectedModel = rememberViewModel(
        thunderDetection.detection.uuid
    ) {
        model.createThunderDetectionSelectedModel(thunderDetection)
    }
    val selectedThunderDetectionSelectedModelState by selectedThunderDetectionSelectedModel.states.collectAsState()

    NavigatorLocalProvider(selectedThunderDetectionSelectedModel) {
        selectedThunderDetectionSelectedModel.navigator = LocalNavigator.current
        val navigator = LocalNavigator.current

        LaunchedEffect(model, scaffoldState) {
            selectedThunderDetectionSelectedModel.mainCompositionScope = scope
            selectedThunderDetectionSelectedModel.scaffoldState = scaffoldState
        }

        LaunchedEffect(selectedThunderDetection, appModelState.selectedThunderDetection) {
            if (null == appModelState.selectedThunderDetection) {
                return@LaunchedEffect
            }

            val uuidLeft = selectedThunderDetection?.detection?.uuid
            val uuidRight = appModelState.selectedThunderDetection?.detection?.uuid

            if (uuidLeft == uuidRight) {
                return@LaunchedEffect
            }

            selectedThunderDetectionSelectedModel.show(RouterDetection.navigateTo(thunderDetection))
        }

        var currentRoute = selectedThunderDetectionSelectedModelState.currentRoute

        val onMenuItemSelected: (String, NavigateTo) -> Unit = { newTitle, path ->
            selectedThunderDetectionSelectedModel.show(path)
        }

        val drawerContent: @Composable (
            Modifier,
            (String, NavigateTo) -> Unit,
            Boolean
        ) -> Unit = { modifier, onMenuItemSelected, tiny ->
            DrawerContentNormal(
                modifier = modifier,
                currentRoute = currentRoute,
                tiny = tiny,
                currentThunderDetection = thunderDetection,
                onMenuItemSelected = onMenuItemSelected
            )
        }

        CompositionLocalProvider(
            LocalMenuState provides scaffoldState,
            LocalAppBarProvider provides selectedThunderDetectionSelectedModel,
            LocalThunderDetectionModel provides selectedThunderDetectionSelectedModel
        ) {
            SafeArea(
                SafeAreaBehavior(
                    extendToTop = true,
                    extendToBottom = true,
                    extendToStart = true,
                    extendToEnd = true
                )
            ) {
                Column {
                    Scaffold(
                        scaffoldState = scaffoldState,
                        topBar = { TopBarWrapper(disableMenuInBigScreen = true) },
                        floatingActionButton = { FloatingActionButtonWrapper() },
                        drawerContent = {
                            drawerContent(
                                Modifier.fillMaxSize(),
                                onMenuItemSelected,
                                false
                            )
                        },
                        drawerShape = DrawerSizeShape(),
                        content = {
                            ScaffoldContentWrapper(
                                selectedThunderDetectionSelectedModel,
                                possibleRoutes = PossibleRoutes.entriesDetectionSelected,
                                defaultRoute = currentRoute,
                                // drawerContent = drawerContent,
                                onMenuItemSelected = onMenuItemSelected
                            )
                        }
                    )
                }
            }
        }
    }
}
